


























import Vue from 'vue';
import Component from 'vue-class-component';
import 'reflect-metadata';
import { inject } from 'vue-typescript-inject';
import { Initialize } from '@/providers/initialize';

@Component({
  providers: [
    Initialize,
  ],
})
export default class App extends Vue {

  /**
   * Initializeオブジェクト
   */
  @inject()
  private initialize!: Initialize;

  /**
   * createdフック
   */
  public created(): void {
    // htmlにクラス追加
    this.initialize.setHtmlClass();
  }

  /**
   * mountedフック
   */
  public mounted(): void {
    // スクロールアニメーション
    const SmoothScroll: any = require('smooth-scroll');
    const scroll: any = new SmoothScroll('a[href*="#"]', {
      speed: 500,
      speedAsDuration: true,
      easing: 'easeInQuad',
    });
  }

}
